import axios from 'axios';

let instance = axios.create({
    baseURL: process.env.VUE_APP_API_URL
});

//TODO убрать или отрефакторить, вываливаться каждый раз надоедает
instance.interceptors.request.use(function (config) {
    config.headers['Api-Key'] = process.env.VUE_APP_API_KEY;
    config.headers['Client-Id'] = process.env.VUE_APP_CLIENT_ID;
    return config;
});

export const $http = instance;
